module.exports = __webpack_public_path__ + "d0b9f3d39664ce9c4d51c228a6400a77.svg";